/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useState, useEffect } from 'react';
import { useTranslation } from '@scuf/localization';
import descriptors from '../../../../locales/en-US/descriptors';
import withErrorStatus from '../../../shared/StatusWrappers/ErrorStatus';
import withLoadingStatus from '../../../shared/StatusWrappers/LoadingStatus';
import {
  ICarbonScopeOneData,
  IDetailComponentProps
} from '../../../DashboardKPIWidgets/IEnergyManagementProps';
import { Card } from '@scuf/common';
import { CarbonScopeOneSavingsByMeterComponentContent } from '../CarbonScopeOneSavingsByMeterWidget/CarbonScopeOneSavingsByMeterComponent';

const CarbonScopeTwoSavingsByMeterComponentWithLoader = withLoadingStatus(
  withErrorStatus(CarbonScopeOneSavingsByMeterComponentContent)
);

const CarbonScopeTwoSavingsByMeterComponent = (
  props: IDetailComponentProps
) => {
  const { dataConnector, UtilityBillType, scope } = props;

  const [t] = useTranslation();
  const d = descriptors.energyManagement;

  const { all, loading, error, status } = dataConnector.data;
  const carbonScopeTwoSiteData = (all as unknown) as ICarbonScopeOneData;
  const isDataAvailable = carbonScopeTwoSiteData ? true : false;
  const [data, setData] = useState({} as ICarbonScopeOneData);
  const [isLoading, setIsLoading] = useState<boolean>(loading);
  const [statusCode, setStatusCode] = useState<number | null>(0);
  const [errorInfo, setErrorInfo] = useState(error);
  const onRefresh = () =>
    dataConnector && dataConnector.actions && dataConnector.actions.getAll();

  useEffect(() => {
    setIsLoading(loading);
    if ((isDataAvailable || error || status) && !loading) {
      if (isDataAvailable) {
        setData(carbonScopeTwoSiteData);
      }
      setErrorInfo(error);
      setStatusCode(status);
    }
  }, [isDataAvailable, loading, status]);

  return (
    <Card className="Savemeter">
      <Card.Header className="emaas-carbon-view-details-total-emissions-savings-meter-card-header">
        {t(d.breakdownCarbon)}
      </Card.Header>
      <Card.Content>
        <div className="meter-savings-Datatable detail-view">
          <CarbonScopeTwoSavingsByMeterComponentWithLoader
            loading={isLoading}
            error={errorInfo}
            statusCode={statusCode}
            onRefresh={onRefresh}
            data={data}
            loadingText={t(d.LOADING)}
            title={t(d.CONNECTIONERRORTITLE)}
            noDataMessage={t(d.NODATAAVAILABLE)}
            connectionErrorMessage={t(d.CONNECTIONERROR)}
            UtilityBillType={UtilityBillType}
            scope={scope}
          />
        </div>
      </Card.Content>
    </Card>
  );
};
export default CarbonScopeTwoSavingsByMeterComponent;
